import {
    GET_UPDATE_REQUEST ,
     GET_UPDATE_SUCCESS, 
     GET_UPDATE_FAILURE, 
  } from "../actions/actionTypes";
import apiClient from "../../utils/apiClient";
  
  export const getUpdateRequest = (individualId) => {
    return async (dispatch) => {

      dispatch({ type: GET_UPDATE_REQUEST });
    
      try {
        const response = await apiClient.post(
          "/getupdaterequest",
          {
            individualId,
          }
        );

        const data = response.data;
   
       dispatch({ type: GET_UPDATE_SUCCESS, payload: data });
  
  
      } catch (error) {
      
        dispatch({
          type:     GET_UPDATE_FAILURE,          
          payload:
            error.response?.data?.message || error.message || "Failed to fetch records. Please try again later.",
        });
      }
    };
  };
